import React from 'react';
import styled from 'styled-components';

const ProgressContainer = styled.div`
  margin-bottom: ${props => props.className?.includes('mb-0') ? '0' : '2rem'};
  width: 100%;
`;

const StepInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.textSecondary};
  
  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const StepText = styled.span`
  color: ${props => props.theme.textSecondary};
`;

const PercentageText = styled.span`
  color: ${props => props.theme.textSecondary};
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${props => props.theme.progressBg};
  border-radius: 9999px;
  overflow: hidden;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background-color: ${props => props.theme.selectedBorder};
  border-radius: 9999px;
  width: ${props => props.percentage}%;
  transition: width 0.5s ease-out;
`;

const ProgressBar = ({ currentPage, totalPages, className }) => {
  // Calculate percentage
  const percentage = Math.round((currentPage / totalPages) * 100);
  
  return (
    <ProgressContainer className={className}>
      <StepInfo>
        {/* <StepText>
          Step {currentPage} of {totalPages}
        </StepText> */}
        <PercentageText>
          {percentage === 100 ? 99 : percentage > 100 ? 100 : percentage}% Complete
        </PercentageText>
      </StepInfo>
      
      <ProgressBarContainer>
        <ProgressBarFill percentage={percentage} />
      </ProgressBarContainer>
    </ProgressContainer>
  );
};

export default ProgressBar;